import useOneToOne from "@/utils/hooks/useOneToOne";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useEffect } from "react";
import cn from "classnames";
import { useBookOneToOneMutation } from "@/data/one-to-one.ts";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import Button from "@edusogno/primitives/loading-button";
import { useMe } from "@/data/user.ts";
import AbsoluteBackground from "@/components/ui/AbsoluteBackground.tsx";
import { useTranslation } from "react-i18next";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

const Confirm = () => {
  const { date, hour, tutor } = useOneToOne();
  const newDate = dayjs(date);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const { me } = useMe();

  useEffect(() => {
    if (!date && !hour) {
      navigate(routes.one_to_one);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, hour]);

  const { mutate, isLoading } = useBookOneToOneMutation();
  const handleConfirm = () => {
    
    if (!me) return;
    mutate({
      tutor_token: tutor,
      user_token: me.item.user.token,
      data: newDate.format("YYYY-MM-DD"),
      ora: hour!,
      ora_fine: dayjs(newDate.format("YYYY-MM-DD") + " " + hour!)
        .add(1, "hour")
        .format("HH:mm"),
      titolo_argomento: "General topic",
      descrizione: "General topic",
      id_material: 751,
    });
  };

  return (
    <>
      <AbsoluteBackground className={"bg-brand-background-light"} />
      <DashboardContentLayout className="z-10 h-full ">
        {/*<div className="h-full max-w-md min-h-full mx-auto md:px-4 xl:px-8">*/}
        <header className={"flex flex-col"}>
          <p className={"text-brand text-xl font-semibold"}>
            {/* Do you want to confirm? */}
            {t("one_to_one.confirm_first_session_modal.mobile_title")}
          </p>
          <p className="mb-2 sub-heading text-primary">
            {/* An event will be created in your&nbsp;
              <b className="text-secondary">Agenda</b> */}
            {t("one_to_one.confirm_first_session_modal.subtitle")}
          </p>
        </header>
        <div className=" flex flex-col items-center justify-between h-full w-full my-[25px]">
          <CalendarIllustration
            day={newDate.format("DD")}
            month={newDate.format("MMM")}
            header={newDate.format("ddd")}
            className={cn(
              "w-2/3 border-solid border-2 rounded-md",
              "block text-center translate-x-1",
            )}
          />
          <div className="flex flex-col items-center gap-8 my-auto h-fit">
            <div className={"mt-4"}>
              <h5 className={"text-brand text-15px"}>
                {/* Time */}
                {t("one_to_one.confirm_first_session_modal.time.title")}
              </h5>
              <p className={"text-brand-secondary font-semibold text-xl"}>
                {hour}
              </p>
            </div>

            <div>
              <h5 className={"text-brand text-15px"}>
                {/* Duration */}
                {t("one_to_one.confirm_first_session_modal.duration.title")}
              </h5>
              <p className={"text-brand-secondary font-semibold text-xl"}>
                {/* 1 hour */}
                {t("one_to_one.confirm_first_session_modal.duration.info")}
              </p>
            </div>
          </div>
        </div>
        <div
          className={
            "flex mt-6 w-full justify-between flex-1 flex-grow gap-x-2 px-6"
          }
        >
          <Button color={"white"} onClick={() => navigate(-1)}>
            {/* Go back */}
            {t("btns.back")}
          </Button>
          <Button
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}
            className="flex items-center justify-center gap-1"
          >
            {/* Confirm */}
            {t("btns.confirm")}
          </Button>
        </div>
        {/*</div>*/}
      </DashboardContentLayout>
    </>
  );
};

export default Confirm;
